import { useRecoilValue } from 'recoil'
import { useState } from 'react'
import useRegularTable from '../../../../../../shared/Tables/Table/ctrl/useRegularTable.ts'
import Table from '../../../../../../shared/Tables/Table'
import equipmentModelsAtom from '../../equipmentModels.atom.ts'
import EquipmentModelSidePage from '../EquipmentModelSidePage'
import { IEquipmentModel } from '../../equipmentModels.types.ts'
import equipmentModelsTableFields from './equipmentModelsTable.fields.ts'

const EquipmentModelsTable = () => {
  const items = useRecoilValue(equipmentModelsAtom).items

  const [isSidePageOpen, setIsSidePageOpen] = useState(false)
  const [selectedModelId, setSelectedModelId] = useState<IEquipmentModel['id']>(null)

  const tableCtrl = useRegularTable({
    fields: equipmentModelsTableFields,
    tableKey: `equipment/models`,
    itemKey: 'id',
    items: items,
  })

  return (
    <>
      <Table
        {...tableCtrl}
        items={items as any}
        itemKey="id"
        onClick={(item) => {
          setSelectedModelId(item.id)
          setIsSidePageOpen(true)
        }}
        loading={false}
      />
      <EquipmentModelSidePage onClose={() => setIsSidePageOpen(false)} id={selectedModelId} open={isSidePageOpen} />
    </>
  )
}

export default EquipmentModelsTable
